"use client";
import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import axios from "axios";
import"./index.css"
import PageTitle from "@/components/common-components/page-title/PageTitle";
import AboutUsSection from "@/components/common-components/about-us-section/AboutUsSection";
import FaqSection from "@/components/common-components/faqs/FaqSection";
const WhatWeDo = dynamic(() => import("./WhatWeDo"), { ssr: false });
const OurTeam = dynamic(() => import("./OurTeam"), { ssr: false });

import { generateCacheKey, withManualCache } from "@/utlility/cache-service";

const API_URL = process.env.NEXT_PUBLIC_API_URL;
const ORG_KEY = process.env.NEXT_PUBLIC_ORGANIZATION_KEY;

const AboutUs = () => {
  const [pageData, setPageData] = useState({
    loading: true,
    aboutUsContents: [],
    aboutUsSubSection: [],
    missionVisionContents: [],
    missionVisionSubSection: [],
    ourTeamContents: [],
    imageUrl: "",
  });

  useEffect(() => {
    const fetchAboutUsPage = async () => {
      try {
        const url = `${API_URL}/api/page-data`;
        const params = {
          organization_key: ORG_KEY,
          slug: "about-us",
        };
        const cacheKey = generateCacheKey(url, 'GET', params);

        const result = await withManualCache(cacheKey, async () => {
          const response = await axios.get(url, { params });
          return response.data;
        });

        if (result?.data) {
          const { section_content_url, data } = result.data;
          const findSection = (slug) => data.find((section) => section.slug === slug);

          const aboutUs = findSection("about-us-hero-section");
          const missionVision = findSection("our-vision-and-mission");
          const ourTeam = findSection("our-team");

          setPageData({
            loading: false,
            imageUrl: section_content_url,
            aboutUsContents: aboutUs?.section_contents || [],
            aboutUsSubSection: aboutUs?.sub_sections || [],
            missionVisionContents: missionVision?.section_contents || [],
            missionVisionSubSection: missionVision?.sub_sections || [],
            ourTeamContents: ourTeam?.section_contents || [],
          });
        }
      } catch (error) {
        // console.error("Error fetching about-us page data:", error);
        setPageData((prev) => ({ ...prev, loading: false }));
      }
    };

    fetchAboutUsPage();
  }, []);

  return (
    <>
      <PageTitle
        image="/images/about-us-bg.webp"
        name="About Us"
        link={"/about-us"}
      />
      <AboutUsSection
        content={pageData.aboutUsContents}
        subSections={pageData.aboutUsSubSection}
        imageUrl={pageData.imageUrl}
        isHome={false}
      />
      <WhatWeDo
        missionVisionContents={pageData.missionVisionContents}
        subSections={pageData.missionVisionSubSection}
      />
      <OurTeam ourTeamContents={pageData.ourTeamContents} />
      <FaqSection />
    </>
  );
};

export default AboutUs;

